import { FilePreview } from "@/components/ui/file-preview";
import { getColorClassForState } from "@/utils/utils";
import { formatDollars, formatDate } from "@common/components/utils";
import { StipendExpense } from "@common/utils/graphql";
import { CaretRight } from "@phosphor-icons/react";
import { titleCase } from "title-case";
import { PaymentMethod } from "./PaymentMethod";
import { Body } from "@hypercard/web-components";
import { Separator } from "@/components/ui/separator";

interface Props {
  expense: StipendExpense;
  onView: (id: string) => void;
}

export const StipendMiniCard = ({ expense, onView }: Props) => {
  return (
    <div className="flex flex-row gap-3">
      <div className="mt-3 flex w-full flex-col rounded-md bg-[#1B1B1B] p-3">
        <div className="flex justify-between">
          <div>
            <div>{expense.merchantName}</div>
            <div className="text-sm text-slate">
              {formatDate(expense.transactionDate)}
            </div>
          </div>
          <div className="flex flex-col items-end justify-end">
            <div>{formatDollars(expense.amount)}</div>
            <div className="flex items-center gap-2">
              {expense.displayPayoutMethod && (
                <>
                  <PaymentMethod size="xs" stipendExpense={expense} />
                  <Separator orientation="vertical" className="bg-white/10" />
                </>
              )}
              <Body
                size="sm"
                weight="regular"
                className={getColorClassForState(expense.status)}
              >
                {expense.isAutoApproved
                  ? "Auto-Approved"
                  : titleCase(expense.status!)}
              </Body>
            </div>
          </div>
        </div>
        <div className="flex justify-between pt-2">
          <div>
            <FilePreview url={expense.receiptFileUrl} />
          </div>
          <div
            className="flex cursor-pointer justify-center align-middle text-sm"
            onClick={() => onView(expense?.stipendExpenseId)}
          >
            See Details <CaretRight className="inline size-4 pt-1" />
          </div>
        </div>
      </div>
    </div>
  );
};
